import Window from 'window-or-global'

export const getObject = namespace => {
  try {
    return JSON.parse(
      Window.localStorage.getItem(namespace)
    )
  } catch (_e) {
    Window.console.warn('getObject: invalid JSON found in localStorage')
    return null
  }
}

export const setObject = (namespace, value) => Window.localStorage.setItem(
  namespace,
  JSON.stringify(value)
)

export const getString = namespace => {
  const value = Window.localStorage.getItem(namespace)
  return value === null ? null : `${value}`
}

export const setString = (namespace, value) => Window.localStorage.setItem(
  namespace,
  `${value}`
)

export const getNumber = namespace => {
  const value = Window.localStorage.getItem(namespace)
  return value === null ? null : Number(value)
}

export const setNumber = (namespace, value) => Window.localStorage.setItem(
  namespace,
  `${Number(value)}`
)

export const getBoolean = namespace => {
  const value = Window.localStorage.getItem(namespace)
  switch (value) {
    case null: return null
    case 'true': return true
    case 'false': return false
    default: return null
  }
}

export const setBoolean = (namespace, value) => Window.localStorage.setItem(
  namespace,
  value ? 'true' : 'false'
)

export const remove = namespace => Window.localStorage.removeItem(namespace)

export const getAllKeys = () => Object.keys(Window.localStorage)
